import * as errorTexts from '../../const/ErrorMessages/ComplaintPositionErrorMessages';
import moment from 'moment';
import {IS_INTERNAL_APP} from '../../api/ApiSettings';
import {GetSalesDocumentNumberId} from '../../api/ApiCalls';

export function validateWarrantyPosition(position) {
    validateProduct(position.product);
    validateAmount(position.amount);
    validateFaultDescription(position.faultDescription);
    validateFaultDate(position.faultDate, moment());
    //validateArticleSerialNumber(position.articleSerialNumber);
    validateIsPurchaseProof(position.purchaseProve);
    validateArticlePurchaseDate(position.articlePurchaseDate, moment());
    //validateArticleAssemblyAddress(position.articleAssemblyAddress);
    validateQuantityCorrectionsProposal(position.quantityCorrectionsProposal);
    if(IS_INTERNAL_APP === false) {
        validateFaultDiscoveryCircumstances(position.faultDiscoveryCircumstances);
        validateSalesDocumentNumber(position.salesDocumentNumber);
        validateCustomerRequest(position.customerRequest);
        validateIsAnyFile(position.files);
    }
}

export function validateSalesWarrantyPosition(position) {
    validateProduct(position.product);
    validateAmount(position.amount);
    validateFaultDescription(position.faultDescription);
    validateFaultDate(position.faultDate, moment());
    //validateArticleSerialNumber(position.articleSerialNumber);
    validateIsPurchaseProof(position.purchaseProve);
    validateArticlePurchaseDate(position.articlePurchaseDate, moment());
    //validateArticleAssemblyAddress(position.articleAssemblyAddress);
    validateQuantityCorrectionsProposal(position.quantityCorrectionsProposal);
    if(IS_INTERNAL_APP === false) {
        validateFaultDiscoveryCircumstances(position.faultDiscoveryCircumstances);
        validateSalesDocumentNumber(position.salesDocumentNumber);
        validateShipmentDescription(position.shipmentDescription);
        validateIsAnyFile(position.files);
    }
}

export async function validateThatSalesDocumentExists(complaintPosition, complaintType, customer) {
    switch (complaintType.name) {
        case "DeliveryMismatch", "TransportDamage": 
            await validateThatSalesDocumentExistsInternal(complaintPosition.salesDocumentNumber, customer.id);
        break;
    }
}


export function validateDeliveryMismatchPosition(position) {
    validateProduct(position.product);
    if(IS_INTERNAL_APP === false) {
        validateSalesDocumentNumber(position.salesDocumentNumber);
        validateSalesDocumentPosition(position.salesDocumentPosition);
        
    }
    validateInvoiceQuantity(position.invoiceQuantity);
    validateShippedQuantity(position.shippedQuantity);
    validateQuantityCorrectionsProposal(position.quantityCorrectionsProposal);
}

export function validatePayedRepairPosition(position) {
    validateProduct(position.product);
    validateAmount(position.amount);
    validateFaultDescription(position.faultDescription);
    validateFaultDate(position.faultDate, moment());
    if(IS_INTERNAL_APP === false) {
        validateFaultDiscoveryCircumstances(position.faultDiscoveryCircumstances);
        validateShipmentDescription(position.shipmentDescription);
    }
    validateTermOfUse(position.termOfUse);
}

export function validateUnderWarrantyLaserDeviceCalibrationPosition(position) {
    validateProduct(position.product);
    validateAmount(position.amount);
    if(IS_INTERNAL_APP === false) {
        validateFaultDiscoveryCircumstances(position.faultDiscoveryCircumstances);
        validateSalesDocumentNumber(position.salesDocumentNumber);
        validateShipmentDescription(position.shipmentDescription);
        validateIsAnyFile(position.files);
    }
}

export function validatePostWarrantyLaserDeviceCalibrationPosition(position) {
    validateProduct(position.product);
    validateAmount(position.amount);
    validateFaultDescription(position.faultDescription);
    if(IS_INTERNAL_APP === false) {
        validateShipmentDescription(position.shipmentDescription);
    }
    validateTermOfUse(position.termOfUse);
}

 export function validateTransportDamagePosition(position) {
    validateProduct(position.product);
    validateAmount(position.amount);
    validateFaultDescription(position.faultDescription);
    validateDateOfReceiptOfGoods(position.dateOfReceiptOfGoods, moment());
    if(IS_INTERNAL_APP === false) {
        validateSalesDocumentNumber(position.salesDocumentNumber);
        validateSalesDocumentPosition(position.salesDocumentPosition);
        validateIsAnyFile(position.files);
    }
    validateCourier(position.courier);
}


function validateSalesDocumentNumber(salesDocumentNumber) {
    if(salesDocumentNumber === "") {
        throw new Error(errorTexts.EMPTY_SALES_DOCUMENT_NUMBER);
    }
}

async function validateThatSalesDocumentExistsInternal(salesDocumentNumber, customerId) {
    if(IS_INTERNAL_APP === false) {
        let documentId = null;
        try {
            let response = await GetSalesDocumentNumberId(salesDocumentNumber, customerId);
            const result =  await response.json();
            if(response.status===200) {
                documentId = result;
            } 
        } catch (fetchError) {
            throw new Error(errorTexts.FETCH_ERRROR_GET_SALES_DOCUMENT_BY_NUMBER_AND_CUSTOMER_ID);
        }
        if(documentId ===null) {
            throw new Error(errorTexts.SALES_DOCUMENT_DOESNT_EXISTS);
        }
    }
}

function validateSalesDocumentPosition(salesDocumentPosition) {
    if(salesDocumentPosition === "") {
        throw new Error(errorTexts.EMPTY_SALES_DOCUMENT_POSITION);
    }
}

function validateDateOfReceiptOfGoods(dateOfReceiptOfGoods, currentDate) {
    if (currentDate.format("YYYY/MM/DD") < dateOfReceiptOfGoods.format("YYYY/MM/DD")) {
        throw new Error(errorTexts.INVALID_FAULT_DATE);
    }
}

function validateCourier(courier) {
    if(courier.value === "NotSpecified") {
        throw new Error(errorTexts.UNSELECTED_COURIER);
    }
}

function validateShipmentDescription(shipmentDescription) {
    if(shipmentDescription === "") {
        throw new Error(errorTexts.EMPTY_SHIPMENT_DESCRIPTION);
    }
}

function validateTermOfUse(termOfUse){
    if (termOfUse ===false){
        throw new Error(errorTexts.UNSELECTED_TERM_OF_USE);
    }
}

function validateQuantityCorrectionsProposal(quantityCorrectionsProposal){
    if(quantityCorrectionsProposal.value==="NotSpecified")
        throw new Error(errorTexts.UNSELECTED_QUANTITY_CPRRECTIONS_PROPOSAL);
}

function validateProduct(product) {
    if (product===null || JSON.stringify(product) === JSON.stringify({
        code: "",
        name: ""
    })){
        throw new Error(errorTexts.UNSELECTED_PRODUCT);
    }
}

function validateAmount(amount) {
    if (amount <= 0 ) {
        throw new Error(errorTexts.AMOUNT_VALUE_IS_ZERO_OR_LESS_THAN_ZERO);
    }
}

function validateFaultDescription(faultDescription) {
    if (faultDescription ==="") {
        throw new Error(errorTexts.EMPTY_FAULT_DESCRIPTION);
    }
}

function validateFaultDate(faultDate, currentDate) {
    if (faultDate.format("YYYY/MM/DD") > currentDate.format("YYYY/MM/DD")) {
        throw new Error(errorTexts.INVALID_FAULT_DATE);
    }
}

function validateFaultDiscoveryCircumstances(faultDiscoveryCircumstances) {
    if (faultDiscoveryCircumstances ==="") {
        throw new Error(errorTexts.EMPTY_FAULT_DISCOVERY_CIRCUMSTANCES);
    }
}

function validateCustomerRequest(customerRequest) {
    if (customerRequest ==="") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_REQUEST);
    }
}

function validateIsAnyFile(files) {
    if (files.length ===0) {
        throw new Error(errorTexts.NO_FILES_ADDED);
    }
}

function validateIsPurchaseProof(files) {
    if (files.length ===0) {
        throw new Error(errorTexts.NO_PURCHASE_PROOF);
    }
}
 
function validateArticlePurchaseDate(articlePurchaseDate) {
    const date = new Date();
    if (articlePurchaseDate > date) {
        throw new Error(errorTexts.INCORRECT_PURCHASE_DATE); 
    }
    if(articlePurchaseDate === "" || articlePurchaseDate === null ){
        throw new Error(errorTexts.PURCHASE_DATE_REQUIRE);
    }
}
/* 
function validateArticleAssemblyAddress(articleAssemblyAddress){
    if (articleAssemblyAddress === "") {
        throw new Error(errorTexts.EMPTY_ASSEMBLY_ADDRESS);
    }
} */

function validateInvoiceQuantity(invoiceQuantity) {
    if(invoiceQuantity < 0) {
        throw new Error(errorTexts.EMPTY_INVOICE_QUANTITY);
    }
}

function validateShippedQuantity(shippedQuantity) {
    if(shippedQuantity < 0) {
        throw new Error(errorTexts.EMPTY_SHIPPED_QUANTITY);
    }
}

/* function validateArticleSerialNumber(articleSerialNumber) {
    if(articleSerialNumber === "") {
        throw new Error(errorTexts.EMPTY_ARTICLE_SERIAL_NUMBER);
    }
    if(articleSerialNumber.length < 22) {
        throw new Error(errorTexts.TOSHORT_ARTICLE_SERIAL_NUMBER);
    }
    if (articleSerialNumber.length > 23) {
        throw new Error(errorTexts.TOLONG_ARTICLE_SERIAL_NUMBER);
    }
}
 */


// WEBPACK FOOTER //
// ./src/actions/Validators/ComplaintPositionValidator.js